import React, { useState, useEffect } from 'react'
import { Row, Col, Button, message } from 'antd';
import { genVRoomToken, getRoomHistory, isValidName, IconHelper, setCookie, getCookie, deleteCookie } from '../../helpers'
import { translate } from 'react-i18next'
import FooterContent from './FooterContent'
import RoomList from './RoomList'
import Banner from './Banner'
import { AutoComplete } from 'antd';
import { useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash'

import analytics from "../../libs/analytics"

const LandingView = ({ keycloak, authenticated, t, language }) => {
    const { IconClose, IconKeyboard } = IconHelper
    const [room, setRoom] = useState('')
    const [roomHistory, SetRoomHistory] = useState([])
    const [showPopupCookie, setShowPopupCookie] = useState(true)
    const acceptCookie = getCookie('acceptCookie')
    const [hideMessageNoti, setHideMessageNoti] = useState(false)
    // vroom name error.
    const [nameError, setnameError] = useState({
        isError: false,
        message: null
    })
    const [nameEmpty, setnameEmpty] = useState({
        isEmpty: false,
        message: null
    })
    const [autocompleteList, setautocompleteList] = useState([])
    const conference = useSelector(state => state.conference.conferencesList)
    const messageNoti = useSelector(state => state.messageNoti)

    useEffect(() => {
        setFixHeight()
        window.addEventListener('resize', setFixHeight);
        const history = getRoomHistory();
        SetRoomHistory(history)
    }, [])

    useEffect(() => {
        const getOptions = () => {
            let arr = [];
            if (!authenticated) {
                const roomList = roomHistory.map((room, k) => {
                    let l = document.createElement("a");
                    l.href = room.conference;
                    let name = l.pathname.substring(1)
                    let roomName
                    let pathnameTmp = name.replace(/%20/g, ' ')
                    if (/(?!%22)[!@#$%^&*]/.test(pathnameTmp)) {
                        roomName = decodeURIComponent(name)
                    } else {
                        roomName = name
                    }
                    return roomName
                })
                roomList.forEach((v, k) => {
                    let roomName
                    let pathnameTmp = v.replace(/%20/g, ' ')
                    if (/(?!%22)[!@#$%^&*]/.test(pathnameTmp)) {
                        roomName = v
                    } else {
                        roomName = decodeURIComponent(v)
                    }
                    let result = { value: roomName }
                    arr.push(result)
                })
            } else {
                const conferenceList = []
                conference.forEach(element => {
                    if (conferenceList.indexOf(element.name) === -1) {
                        conferenceList.push(element.name)
                    }
                });
                conferenceList.forEach((v, k) => {
                    let roomName
                    let pathnameTmp = v.replace(/%20/g, ' ')
                    if (/(?!%22)[!@#$%^&*]/.test(pathnameTmp)) {
                        roomName = v
                    } else {
                        roomName = decodeURIComponent(v)
                    }
                    let result = { value: roomName }
                    arr.push(result)
                })
            }
            return arr;
        }
        setautocompleteList(getOptions())
    }, [roomHistory, authenticated, conference])


    const setFixHeight = () => {
        const fixHeight = document.getElementsByClassName('fixHeight')[0]
        const nav = document.getElementsByClassName('nav')[0]
        const footContent = document.getElementsByClassName('foot-content')[0]
        const windowWidth = window.innerHeight
        if (footContent && getRoomHistory().length === 0) {
            if (windowWidth > 900) {
                footContent.style.position = 'absolute'
            } else {
                footContent.style.position = 'relative'
            }
        }
        if (fixHeight) {
            fixHeight.style.height = `${window.innerHeight - nav.offsetHeight}px`
        }
    }

    const onReservationPage = async () => {
        //let spaceTrim = room.replace(/ /g, '');
        setnameEmpty({
            isEmpty: false,
            message: ""
        })

        analytics.sendEvent({
            category:'Home',
            action: 'Homepage-StartMeeting-Button-Clicked',
        });

        if (isValidName(room)) {

            if (authenticated) {
                const vRoomToken = await genVRoomToken(keycloak)
                window.location.href = `${window._env_.vRoomUrl}/${room.trim()}?jwt=${vRoomToken}`
            } else {
                window.location.href = `${window._env_.vRoomUrl}/${room.trim()}`
            }

        } else {
            if (room === "") {
                setnameError({
                    isError: false,
                })
                setnameEmpty({
                    isEmpty: true,
                    message: t("reservation_modal_join.input")
                })
                // message.error(t("reservation_modal_join.input"))
            }
        }
    }

    const onInputKeydown = async (event) => {
        var code = event.keyCode || event.which;
        if (code === 13) {

            //  let spaceTrim = room.replace(/ /g, '');
            if (isValidName(room)) {

                if (authenticated) {
                    const vRoomToken = await genVRoomToken(keycloak)

                    window.location.href = `${window._env_.vRoomUrl}/${room.trim()}?jwt=${vRoomToken}`
                } else {
                    // console.log('test', getBackendSafeRoomName(room.trim()))
                    window.location.href = `${window._env_.vRoomUrl}/${room.trim()}`
                }

            } else {
                if (room === "") {
                    message.error(t("reservation_modal_join.input"))
                }
            }

        }
    }


    const onChange = value => {
        //let spaceTrim = value.replace(/ /g, '');
        setnameEmpty({
            isEmpty: false,
            message: ''
        })
        if (!isValidName(value)) {

            setnameError({
                isError: true,
                message: t("reservation_modal_form_err.name_invalid")
            })
            // return
        } else {
            setnameError({
                isError: false,
                message: ''
            })
            // setRoom(value)
        }
        setRoom(value)

    };

    const onSelect = async value => {
        // let spaceTrim = room.replace(/ /g, '');
        if (isValidName(value)) {

            if (authenticated) {
                const vRoomToken = await genVRoomToken(keycloak)
                window.location.href = `${window._env_.vRoomUrl}/${value.trim()}?jwt=${vRoomToken}`
            } else {
                window.location.href = `${window._env_.vRoomUrl}/${value.trim()}`
            }

        }

    }

    const hidePopupCookie = () => {
        setShowPopupCookie(false)
    }

    const onSubmitCookie = () => {
        analytics.sendEvent({
            category:'Home',
            action: 'Homepage-AcceptTermAndCondition-Cookie-Clicked',
        });
        setCookie('acceptCookie', true)
        hidePopupCookie()
    }

    const handleHidePopupCookie = () => {
        analytics.sendEvent({
            category:'Home',
            action: 'Homepage-Cancel-Cookie-Clicked',
            label: 'Popup Cookie',
        });
        hidePopupCookie()
    }

    useEffect(() => {
        if (!isEmpty(messageNoti)) {
            if (getCookie('hideMessageNoti') !== get(messageNoti, '_id', '')) {
                deleteCookie('hideMessageNoti')
            }
            if (isEmpty(messageNoti.message)) {
                setCookie('hideMessageNoti', get(messageNoti, '_id', ''))
            }
        }
    }, [messageNoti])

    const onCloseNoti = () => {
        analytics.sendEvent({
            category:'Home',
            action: 'Homepage-Cancel-GreenBar-Clicked',
            label: 'Header Notification',
        });
        if (!isEmpty(messageNoti)) {
            const { age } = messageNoti
            const getText = age.slice(age.length - 1)
            const expire = age.slice(0, age.length - 1)
            let period = ''
            if (getText === 'm')
                period = 'minutes'
            else if (getText === 'h')
                period = 'hours'
            else {
                period = 'hours'
            }
            setCookie('hideMessageNoti', get(messageNoti, '_id', ''), { period: period, duration: parseInt(expire) })
            setHideMessageNoti(true)
        }
    }

    const gotoReserve = () => {
        
        analytics.sendEvent({
            category:'Home',
            action: 'Homepage-ScheduleMeeting-Button-Clicked',
        });

        if (isValidName(room)) {
            window.location.href = `${window._env_.mymeeting}?reserve=true&room=${room}`
        } else {
            if (room === '') {
                window.location.href = `${window._env_.mymeeting}?reserve=true`
            } else {
                setnameError({
                    isError: true,
                    message: t("reservation_modal_form_err.name_invalid")
                })
            }
        }
    }

    return (

        <>
            <Row className="container fixHeight">
                <Col span={24}>
                    {isEmpty(getCookie('hideMessageNoti') || hideMessageNoti)
                        ? <div className="header-notification">
                            <span dangerouslySetInnerHTML={{ __html: get(messageNoti, `message.${language}`) }} />&nbsp;&nbsp;
                            <IconClose onClick={onCloseNoti} fill="#333333" style={{ width: '20px', cursor: 'pointer' }} />
                        </div>
                        : null}
                    <section className="sec1">
                        <Row type="flex" justify="center">
                            <Col lg={10} md={14} sm={20} xs={20}>
                                <p className="text-landing-head" dangerouslySetInnerHTML={{ __html: t("landing_sec1_head") }} />
                                <p className="text-landing-info" dangerouslySetInnerHTML={{ __html: t("landing_sec1_text") }} />
                                <p className="text-landing-info" dangerouslySetInnerHTML={{ __html: t("landing_sec1_text2") }} />
                            </Col>
                        </Row>
                        <Row type="flex" justify="center">
                            <Col lg={10} md={16} sm={20} xs={20} className="form-room">
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24} className="input-room">
                                        <div id="input-room">
                                            <div className="box-input-room">
                                                <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                                                    <Col span={2} className="icon-input">
                                                        <IconKeyboard style={{ marginLeft: '10px' }} />
                                                    </Col>
                                                    <Col span={22}>
                                                        <AutoComplete
                                                            defaultOpen={false}
                                                            onSelect={onSelect.bind(this)}
                                                            onChange={onChange.bind(this)}
                                                            onKeyPress={onInputKeydown.bind(this)}
                                                            // onKeyUp={(e) => keyup(e)}
                                                            options={autocompleteList}
                                                            filterOption={(inputValue, option) =>
                                                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                            }
                                                            className="input-autocomplete"
                                                            placeholder={t('landing_input_placeholder')}
                                                        >
                                                        </AutoComplete>
                                                    </Col>
                                                </Row>

                                            </div>
                                            {nameError.isError
                                                && <div className="box-valid-room">
                                                    <span className="vroom-name-error">{t("reservation_modal_form_err.name_invalid")} </span>
                                                </div>
                                            }
                                            {nameEmpty.isEmpty
                                                && <div className="box-empty-room">
                                                    <span className="vroom-name-empty">{t("reservation_modal_join.input")} </span>
                                                </div>
                                            }
                                            <Row justify="space-between" gutter={10}>
                                                <Col xs={12}>
                                                    <Button onClick={onReservationPage}>
                                                        {t('landing_btn_submit_go')}
                                                    </Button>
                                                </Col>
                                                <Col xs={12}>
                                                    <Button className="btn-black" onClick={gotoReserve}>
                                                        {t('landing_btn_mymeeting')}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                </Row>
                                <RoomList keycloak={keycloak} authenticated={authenticated} language={language} />
                            </Col>
                        </Row>
                        <Row type="flex" justify="center">
                            <Col lg={14} md={16} sm={20} xs={20}>
                                <Banner keycloak={keycloak} language={language} />
                            </Col>
                        </Row>
                        {showPopupCookie && !acceptCookie
                            && <div className="card-cookie">
                                <Row type="flex" justify="center">
                                    <Col md={18} sm={24}>
                                        <Row>
                                            <Col span={22}>
                                                <span>{t("accept_cookie.header")}</span>
                                            </Col>
                                            <Col span={1}>
                                                <IconClose fill="#000" style={{ cursor: 'pointer' }} onClick={handleHidePopupCookie} />
                                            </Col>
                                        </Row>
                                        <Row type="flex" justify="space-between" align="middle">
                                            <Col md={18} sm={20} xs={21}>
                                                <p>{t("accept_cookie.detail")}</p>
                                            </Col>
                                            <Col md={5} sm={24}>
                                                <Button className="cookie-submit" onClick={onSubmitCookie}>
                                                    {t("accept_cookie.button")}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </section>
                    <section className="foot-content">
                        <FooterContent />
                    </section>
                </Col>
            </Row>
        </>
    )
}

export default translate()(LandingView)